import React from "react";

class LingoBanner extends React.Component {
    render() {
        return (
            <section
                className="banner banner-flex promo site-only full-banner-link"
                data-callback="accounts/hide-banner/LINGO"
                data-banner-show-anonymous="true"
                data-banner-key="lingo"
            >
                <div className="banner-grid row">
                    <a
                        className="no-decoration"
                        href="https://www.lingoapp.com/?utm_source=noun_project&utm_medium=banner&utm_campaign=q1_2020"
                        title="Check out Lingo"
                        target="_blank"
                    >
                        <span className="show-sm">
                            <span className="info">
                                Check out Lingo, our new tool for design assets.
                            </span>
                        </span>
                        <span className="show-lg">
                            <span className="info">
                                Introducing Lingo! Our new tool to help you
                                manage your design assets.
                            </span>
                        </span>
                    </a>
                    <span
                        className="dismiss-banner ui_close"
                        onClick={this.props.bannerDismiss}
                        title="Dismiss banner"
                    />
                </div>
            </section>
        );
    }
}

export default LingoBanner;
